<template>
    <div>
        <div class="row">

            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'home' }">{{ $t("inicio") }}</router-link>
                        </li>
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'configuracion' }">{{ $t("configuracion") }}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{ $t("productos") }}</li>
                    </ol>
                </nav>
            </div>

            <div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-4" v-if="!sectores">
                            <div class="form-group">
                                <label for="listBusiness">{{ $t("negocio") }}</label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    :placeholder="$t('seleccionaNegocio')" @change="cambioNegocio()">
                                    <el-option v-for="business in listBusinesses" class="select-primary"
                                        :value="business.id" :label="business.establishmentName"
                                        :key="business.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div :class="idSector == 0 || verBusinesses == true ? 'col-md-2' : 'col-md-4'" v-else>
                            <div class="form-group">
                                <label for="listSectores">Sector</label>

                                <el-select class="select-default" size="large" v-model="idSector" filterable
                                    @change="cambioSector()" :placeholder="'Seleccionar un sector'">
                                    <el-option v-for="sector in listaSectores" class="select-primary" :value="sector.id"
                                        :label="sector.name" :key="sector.name">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-2" v-if="this.idSector == 0 && this.sectores">
                            <div class="form-group">
                                <label for="listSectores">{{ $t("negocio") }}</label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="cambioNegocio()" :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="negocio in listaNegociosSinSector" class="select-primary"
                                        :value="negocio.id" :label="negocio.establishmentName"
                                        :key="negocio.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="col-md-2" v-if="verBusinesses">
                            <div class="form-group">
                                <label for="listSectores">{{ $t("negocio") }}</label>

                                <el-select class="select-default" size="large" v-model="idBusiness" filterable
                                    @change="cambioNegocio()" :placeholder="$t('seleccionaNegocio')">
                                    <el-option v-for="negocio in listBusinesses" class="select-primary"
                                        :value="negocio.id" :label="negocio.establishmentName"
                                        :key="negocio.establishmentName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <template v-if="permiso">
                            <div v-if="listProductos.length > 0 && respuesta" class="col-md-8 text-right">
                                <label> </label><br>
                                <el-checkbox v-model="verBusinesses" style="margin-top:0px;margin-right:25px"
                                    v-if="sectores && $cookies.isKey('sectores')">
                                    <strong>Ver sin sectores</strong>
                                </el-checkbox>

                                <!-- Dropdown para Exportar Informe -->
                                <el-dropdown v-if="listProductos.length > 0 && respuesta">
                                    <el-button type="primary" size="small">
                                        <i class="fa fa-file"></i>
                                        {{ $t("exportarInforme") }} <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a :href="urlExportPDF">
                                            <el-dropdown-item class="text-danger">
                                                <strong><i class="fa fa-file-pdf"></i> {{ $t("exportarPdf") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcel">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i> {{ $t("exportarExcel") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                        <a :href="urlExportExcelSubproduct">
                                            <el-dropdown-item class="text-success">
                                                <strong><i class="fa fa-file-excel"></i>
                                                    {{ $t("exportarExcelSinSubproductos") }}</strong>
                                            </el-dropdown-item>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <!--<p v-for="sector in listaSectores" :key="sector.id">
                {{sector.name}}
            </p>-->
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <div class="card">

                    <div class="row">
                        <div class="col-md-2">
                            <div class="form-group">
                                <!--{{idSector}}-->
                                <router-link
                                    :to="idSector == 0 || verBusinesses == true ? { name: 'nuevoproducto', params: { 'idBusiness': idBusiness } } : { name: 'nuevoproductosector', params: { 'idBusiness': idBusiness, 'idSector': idSector } }">
                                    <button class="btn btn-primary"><i class="fa fa-plus-square"></i>
                                        {{ $t("agregarProductos") }}
                                    </button>
                                </router-link>
                            </div>
                        </div>

                        <div class="col-md-4 text-right "  v-if="conBusquedaBaja">
                            <div style="margin-top: 4px;" class="form-group justify-content-center" >
                                <el-checkbox class="form-group" 
                                    v-model="isDeBaja" 
                                    @change="changeIsDeBaja()">
                                    <strong>{{ $t("buscarBaja") }}</strong>
                                </el-checkbox>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <el-select class="select-default filterTag" size="large" v-model="filter" filterable
                                @change="cambioFiltro()" :placeholder="$t('seleccionaNegocio')">
                                <el-option v-for="filter in filterTag" class="select-primary" :value="filter.id"
                                    :label="filter.name" :key="filter.id">
                                </el-option>
                            </el-select>
                        </div>


                        <div class="col-md-4">
                            <div class="input-group">
                                <input type="text" class="form-control" v-bind:placeholder="$t('buscar')"
                                    v-model="searchQuery" @keyup.enter.prevent="searchProveedores">
                                <div class="input-group-append">
                                    <button class="btn btn-secondary" type="button" @click="searchProveedores"><i
                                            class="fa fa-search"></i>
                                    </button>
                                    <button class="btn btn-secondary" type="button" @click="removeSearch"><i
                                            class="fa fa-times"></i>
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div class="col-md-12 text-right">
                            <button v-if="!ordenar" class="btn btn-primary" @click="ordenar = true, getProductosOrder()">
                                <i class="fas fa-th-list"></i> {{ $t('vistaFrontalTpv') }}
                            </button>
                            <button v-else class="btn btn-primary" @click="ordenar = false, ordenarProductos = false"><i
                                    class="fas fa-list-ul"></i>
                                {{ $t('vistaLista') }}
                            </button>

                            <!--Editar precios de los productos-->

                            <button v-if="!ordenar && !editarProductos" @click="editarProductos = true"
                                class="btn btn-warning">
                                <i class="fas fa-edit"></i> {{ $t('editarPrecios') }}
                            </button>
                            <button v-if="!ordenar && editarProductos" @click="cancelarEdicion" class="btn btn-danger">
                                <i class="fas fa-undo-alt"></i> {{ $t('cancelarEdicion') }}
                            </button>

                        </div>
                        <div class="col-md-12 text-right">
                            <template v-if="ordenar">
                                <button v-if="ordenar && ordenarProductos" class="btn-success btn-sm"
                                    @click="editProductOrden">
                                    <i class="far fa-save"></i> {{ $t('guardarOrden') }}
                                </button>
                                <input v-model="ordenarProductos" type="checkbox" name="sortProducts"
                                    id="sortProducts" />
                                <label for="sortProducts" style="cursor:pointer;">
                                    <strong>{{ $t('ordenarProductos') }}</strong></label>
                            </template>
                        </div>
                    </div>

                    <div class="row" v-if="isSearch">
                        <div class="col-md-12">
                            <p>
                                <small>{{ showResult }}</small>
                            </p>
                        </div>
                    </div>

                    <div class="row" style="margin-top: 20px">
                        <div class="col-md-12" v-if="respuesta && ordenar">

                            <div class="row">

                                <div class="col-md-3">
                                    <button style="width: 100%;" class="btn-primary btn" :class="{ active: grupo === 1 }"
                                        @click="grupo = 1, getProductosOrder()">{{ $t('grupo') }} 1
                                    </button>
                                </div>

                                <div class="col-md-3">
                                    <button style="width: 100%" class="btn-primary btn" :class="{ active: grupo === 2 }"
                                        @click="grupo = 2, getProductosOrder()">{{ $t('grupo') }} 2
                                    </button>
                                </div>

                                <div class="col-md-3">
                                    <button style="width: 100%" class="btn-primary btn" :class="{ active: grupo === 3 }"
                                        @click="grupo = 3, getProductosOrder()">{{ $t('grupo') }} 3
                                    </button>
                                </div>

                                <div class="col-md-3">
                                    <button style="width: 100%" class="btn-primary btn" :class="{ active: grupo === 4 }"
                                        @click="grupo = 4, getProductosOrder()">{{ $t('grupo') }} 4
                                    </button>
                                </div>


                                <div style="margin-top: 20px" class="col-md-6" v-for="p in listProductOrder">
                                    <div class="row clearfix">
                                        <div class="col-md-12">
                                            <p class="titulo" v-if="p.nameCat !== ''">{{ p.nameCat }}</p>
                                            <p class="titulo" v-else>{{ $t('sinCategoria') }}</p>

                                            <draggable class="row" v-model="p.listProducts" group="people"
                                                @start="start(p.nameCat)" @end="end()" style="padding: 0px 15px;"
                                                :disabled="p.dragging || (!p.dragging && !ordenarProductos)">

                                                <div class="col-md-2 col-4" v-for="element in p.listProducts"
                                                    :key="element.id" style="padding: 0px 2px;">
                                                    <button class="buttonProducto" @click="ruta(element.id)"
                                                        :style="[element.color !== 'negro' ? { 'color': 'black', 'background-color': colorBoton(element.color) } : { 'color': 'white', 'background-color': colorBoton(element.color) }]">

                                                        <template v-if="element.active == '1'"> {{ element.name }}
                                                        </template>
                                                        <template v-else><span
                                                                style="text-decoration:line-through">{{ element.name }}</span>
                                                            {{ $t('bajaConBrackets') }}
                                                        </template>
                                                    </button>
                                                </div>

                                            </draggable>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <template v-if="!ordenar">
                        <div class="table-responsive " v-if="listProductos.length > 0">
                            <table class="table table-bordered table-striped">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>{{ $t("producto") }}</th>
                                        <th>{{ $t("descripcion") }}</th>
                                        <th>{{ $t("codigoBarra") }}</th>
                                        <th>{{ $t("precioDeCoste") }}</th>
                                        <th>{{ $t("impuesto")}}</th>
                                        <th>{{ $t("tarifa1") }}</th>
                                        <th>{{ $t("tarifa2") }}</th>
                                        <th>{{ $t("tarifa3") }}</th>
                                        <th>{{ $t("tarifa4") }}</th>
                                        <th>{{ $t("categoria") }}</th>
                                        <th>{{ $t("acciones") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="p in listProductos">
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.name }}
                                                    <span style="color: red" v-if="p.active == '0'">
                                                        {{ $t('bajaConBrackets') }}
                                                    </span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.name" class="form-control input-sm"
                                                        id="producto-name">
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.description }}
                                                    <span style="color: red" v-if="p.active == '0'">
                                                        {{ $t('bajaConBrackets') }}
                                                    </span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.description"
                                                        class="form-control input-sm" id="producto-name">
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <!--codigo barras -->
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.barcode }}
                                                    <span style="color: red" v-if="p.active == '0'">
                                                    </span>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.barcode" class="form-control input-sm"
                                                        id="producto-barCode">
                                                </div>
                                            </template>
                                        </td>
                                        <!--fin codigo barras -->
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.costprice }}</div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.costprice" class="form-control"
                                                        id="producto-costprice">
                                                </div>
                                            </template>
                                        </td>
                                        <!--IVA-->
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.vatType }}</div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.vatType" class="form-control"
                                                        id="producto-costprice">
                                                </div>
                                            </template>
                                        </td>

                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.price1 }}</div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.price1" class="form-control"
                                                        id="producto-price1">
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.price2 }}</div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.price2" class="form-control"
                                                        id="producto-price2">
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.price3 }}</div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.price3" class="form-control"
                                                        id="producto-price3">
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div>{{ p.price4 }}</div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <input type="text" v-model="p.price4" class="form-control"
                                                        id="producto-price4">
                                                </div>
                                            </template>
                                        </td>
                                        <td>
                                            <template v-if="(!p.modifier || !editarProductos)">
                                                <div v-if="p.nameCat">{{ p.nameCat }}</div>
                                                <div v-else>{{ $t("sinCategoria") }}</div>
                                            </template>
                                            <template v-else>
                                                <div>
                                                    <el-select class="select-default" size="large" v-model="p.idCate"
                                                        filterable :placeholder="$t('seleccionaUnaCategoria')">
                                                        <el-option v-for="filter in filterTagEdit"
                                                            class="select-primary" :value="filter.id"
                                                            :label="filter.name" :key="filter.id">
                                                        </el-option>
                                                    </el-select>
                                                </div>
                                            </template>
                                        </td>
                                        <td style="width: 70px; text-align: center;">

                                            <template v-if="!editarProductos">
                                                <a style="margin-left: 20%"
                                                    :href="urlExportExcelProductSubproduct(p.id)">
                                                    <i class="fa fa-file-excel" style="color: green"
                                                        v-tooltip.top-center="$i18n.t('exportarMateriasPrimasAsociadasAEsteProducto')"></i>
                                                </a>
                                                <router-link
                                                    :to="idSector == 0 || verBusinesses == true ? { name: 'producto', params: { 'idBusiness': idBusiness, 'filtro': filter, 'idProducto': p.id, 'pag': pag } }
                                                    : { name: 'productosector', params: { 'idBusiness': idBusiness, 'idSector': idSector, 'filtro': filter, 'idProducto': p.id, 'pag': pag } }">
                                                    <a class="btn btn-danger btn-link btn-xs">
                                                        <i v-tooltip.top-center="$i18n.t('editar')"
                                                            class="fas fa-pencil-alt" style="color: orange"></i>
                                                    </a>
                                                </router-link>
                                            </template>
                                            <template v-else>

                                                <div class="btn btn-link">
                                                    <template v-if="p.modifier === false">
                                                        <button class="btn btn-primary" @click="p.modifier = true">
                                                            <i v-tooltip.top-center="$i18n.t('editar')"
                                                                class="fas fa-cog"></i>
                                                        </button>
                                                    </template>
                                                    <template v-else>
                                                        <button class="btn btn-success"
                                                            @click="p.modifier = false, editProduct(p)">

                                                            <i v-tooltip.top-center="$t('guardar')"
                                                                class="far fa-save"></i>
                                                        </button>
                                                    </template>
                                                </div>

                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="alert alert-danger" role="alert" v-else>
                            {{ $t("noHayProductosEnEsteNegocio") }}
                        </div>
                        <div class="row" v-if="!isSearch && totalPags > 1">
                            <div class="col-md-12">
                                <nav>
                                    <ul class="pagination flex-wrap">
                                        <li class="page-item" :class="{ 'disabled': pag == 1 }">
                                            <router-link class="page-link"
                                                :to="{ name: 'productos', params: { pag: pag - 1 } }" v-if="pag != 1">&laquo;
                                            </router-link>
                                            <span v-else class="page-link"><span
                                                    aria-hidden="true">&laquo;</span></span>
                                        </li>
                                        <li class="page-item" v-for="n in totalPags" :class="{ active: n == pag }">
                                            <router-link class="page-link" :to="{ name: 'productos', params: { pag: n } }">
                                                {{ n }}
                                            </router-link>
                                        </li>
                                        <li class="page-item" :class="{ 'disabled': pag == totalPags }">
                                            <router-link class="page-link"
                                                :to="{name: 'productos', params: {pag: nextPag}}"
                                                v-if="pag != totalPags">
                                                &raquo;
                                            </router-link>
                                            <span v-else class="page-link"><span
                                                    aria-hidden="true">&raquo;</span></span>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import { DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button, Checkbox } from 'element-ui'
import { Loading } from 'element-ui';
import swal from 'sweetalert2'
import draggable from 'vuedraggable';
import { mapState, mapMutations } from 'vuex';

export default {
    created() {
        //            this.loading = Loading.service({text: 'Cargando...'});
        this.$store.dispatch("setNameRoute", this.$i18n.t("productos"));

        if (!this.sectores && !this.$cookies.isKey("sectores")) {
            this.getBusiness();
            //console.log("No tiene sectores")
        } else {

            if (this.listaSectores.length > 1) {

                this.idSector = this.listaSectores[0].id;
                this.idBusiness = this.listaSectores[0].idBusinessMaster;
                //this.idBusiness = this.$store.getters.idBusiness;

                if (this.$cookies.isKey('viewbusinesses')) {
                    this.verBusinesses = true;
                } else {
                    this.getProductos();
                    this.getProductosOrder();
                    this.getCategory();
                }

            } else {

                //Cargar método local donde me traigo los sectores
                this.getSectores();

            }
        }

        this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

        var filtro = this.$route.query.filtro;
        if (filtro != undefined) {
            this.filter = filtro;
        }


    },
    updated() {


        this.peticionesIniciales++;

        if (this.peticionesIniciales === 3) {
            this.loadingGeneral.close();
        }

    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
        draggable,
    },
    data() {
        return {

            //PRUEBAS INICIO PAGINA
            loadingGeneral: null,
            peticionesIniciales: 0,

            loading: false,
            listBusinesses: [],
            listProductos: ["-"],
            idBusiness: this.$route.params.idBusiness,
            isDeBaja: false,
            conBusquedaBaja: {default: false},
            searchQuery: this.$route.params.query,
            isSearch: false,
            pag: this.$route.params.pag,
            totalPags: 0,
            filter: 0,
            filterTag: [],
            respuesta: true,
            grupo: 1,
            activo: 1,

            listProductOrder: [],
            ordenar: false,
            ordenarProductos: false,


            //Editar Productos
            editarProductos: false,
            filterTagEdit: [],

            //SECTORES
            idSector: 0,
            verBusinesses: false,
            listaNegociosSinSector: [],
        }
    },
    watch: {
        '$route'(to, from) {
            if (to.params.pag) {
                this.pag = to.params.pag;
                this.getProductos();
                this.getProductosOrder();
            } else if (to.params.query) {
                this.query = to.params.query;
                this.getProductos();
                this.getProductosOrder();
            }
        },
        verBusinesses: function (newVal, oldVal) {
            this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

            if (newVal) {

                if (!this.$cookies.isKey('viewbusinesses')) {
                    this.$cookies.set("viewbusinesses", 'true', '1d');
                }

                this.getBusiness();
            } else {
                this.$cookies.remove("viewbusinesses");

                if (this.idSector !== 0) {
                    const sector = this.listaSectores.find(sector => sector.id == this.idSector);

                    this.idBusiness = sector.idBusinessMaster;
                }

                this.getProductos();
                this.getProductosOrder();
                this.getCategory();
            }
        }
    },
    computed: {
        ...mapState(["listaSectores", "sectores", "permiso"]),

        /*lista() {
            return this.$store.state.listaSectores;
        },*/
        
        urlExportPDF() {
            return this.$store.getters.apiUrl + "/products/exportListProducts/PDF?idBusiness=" + this.idBusiness + "&filter=" + this.filter + "&jwt=" + this.$store.getters.jwt
        },

        urlExportExcel() {
            return this.$store.getters.apiUrl + "/products/exportListProductsByCategoriename/Excel?idBusiness=" + this.idBusiness + "&filter=" + this.filter + "&jwt=" + this.$store.getters.jwt
        },

        urlExportExcelSubproduct() {
            return this.$store.getters.apiUrl + "/products/exportSubproductsByProducts/Excel?idBusiness=" + this.idBusiness + "&filter=" + this.filter + "&idProduct=0&jwt=" + this.$store.getters.jwt
        },

        showResult() {
            if (this.listProductos.length == 0) {
                return this.$t('noEncontramosResultadosPara') + this.searchQuery;
            } else {
                const result = this.listProductos.length == 1 ? this.$t('resultado') : this.$t('resultados');
                return this.$t('mostrando') + ' ' + this.listProductos.length + " " + result;
            }
        },
        nextPag() {
            let nextPag = parseInt(this.pag) + 1;
            return nextPag;
        }
    },
    methods: {
        ...mapMutations(['changeListaSectores']),
        urlExportExcelProductSubproduct(idProduct) {
            return (
                this.$store.getters.apiUrl +
                "/products/exportSubproductsByProducts/Excel?idBusiness=" +
                this.idBusiness +
                "&filter=" +
                this.filter +
                "&idProduct="
                + idProduct +
                "&jwt=" +
                this.$store.getters.jwt);
        },

        ruta(id) {
            this.$router.push({
                name: 'producto',
                query: { filtro: this.filter },
                params: {
                    idBusiness: this.idBusiness,
                    idProducto: id,
                    pag: this.pag,
                    idSector: this.idSector
                }
            });

        },

        colorBoton(color) {
            let xColor = '';

            switch (color) {

                case "amarillo": {

                    xColor = "#ffec9f";

                    break;
                }
                case "rojo": {

                    xColor = "#ffbbbb";

                    break;
                }
                case "verde": {

                    xColor = "#c1ffc1";

                    break;
                }
                case "morado": {

                    xColor = "#ffbfff";

                    break;
                }
                case "blanco": {

                    xColor = "#FFFFFF";

                    break;
                }
                case "azul": {

                    xColor = "#cad3ff";

                    break;
                }
                case "naranja": {

                    xColor = "#ffa54a";

                    break;
                }
                case "gris": {

                    xColor = "#bbbbbb";

                    break;
                }
                case "negro": {

                    xColor = "#000000";

                    break;
                }
            }

            return xColor;
        },
        start(nameCategory) {

            this.listProductOrder.forEach(function (x) {
                if (x.nameCat === nameCategory) {
                    x.editado = true;
                } else {
                    x.dragging = true;
                }
            });
        },
        end() {
            this.listProductOrder.forEach(function (x) {
                x.listProducts.forEach(function (d) {
                    x.dragging = false;
                });
            });
        },

        getCategory() {
            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + 'categories/getCategoryGeneralesByProducts', config)
                .then(function (response) {
                    if (response.data.response) {

                        if (response.data.result.length === 0) {

                            let category = {
                                name: vm.$t('todos'),
                                id: 0
                            };

                            vm.filterTag.push(category);
                        }

                        for (let i = 0; i < response.data.result.length; i++) {
                            if (i === 0) {

                                let category = {
                                    name: vm.$t('todos'),
                                    id: 0
                                };

                                vm.filterTag.push(category);
                            }

                            let categoryname = {
                                name: response.data.result[i].name,
                                id: response.data.result[i].id,
                            };

                            vm.filterTagEdit.push(categoryname)
                            vm.filterTag.push(categoryname)
                        }

                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                });
        },
        cambioFiltro() {
            this.pag = 1;
            this.totalPags = 0;
            this.getProductos();
            this.getProductosOrder();

        },
        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {
                    if (response.data.response) {

                        if (vm.$store.getters.idBusiness) {
                            vm.idBusiness = vm.$store.getters.idBusiness;
                        } else {
                            vm.idBusiness = response.data.result[0].id;
                        }

                        vm.listBusinesses = response.data.result;

                        vm.getProductos();
                        vm.getProductosOrder();
                        vm.getCategory();
                    } else {
                        vm.loadingGeneral.close();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getSectores() {
            let config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "general/getBusinessesSectors", config)
                .then(function (response) {

                    if (response.data.response) {
                        response.data.result["sectores"].forEach((sector) => {
                            sector.idBusinessMaster = parseInt(sector.idBusinessMaster);
                            sector.id = parseInt(sector.id);
                        });

                        vm.changeListaSectores(response.data.result["sectores"]);

                        vm.idSector = vm.listaSectores[0].id;
                        vm.idBusiness = vm.listaSectores[0].idBusinessMaster;

                        vm.loadingGeneral.close();

                        //Métodos locales
                        if (vm.$cookies.isKey('viewbusinesses')) {
                            vm.verBusinesses = true;
                        } else {
                            vm.getProductos();
                            vm.getProductosOrder();
                            vm.getCategory();
                        }
                    }
                }).catch(function (error) {
                    console.log(error);
                })
        },
        cambioNegocio() {
            this.loadingGeneral = Loading.service({ text: this.$t('cargando') });

            this.pag = 1;
            this.totalPags = 0;
            this.filterTag = [];
            this.filterTagEdit = [];
            this.filter = 0;

            this.getProductos();
            this.getProductosOrder();
            this.getCategory();
        },

        cambioSector() {
            this.verBusinesses = false;

            this.listaNegociosSinSector = [];
            const sector = this.listaSectores.find(sector => sector.id == this.idSector);

            if (this.idSector == 0) {
                this.idBusiness = sector.negocios[0].id;
                this.listaNegociosSinSector = sector.negocios;
            } else {
                this.idBusiness = sector.idBusinessMaster;
            }

            this.getProductos();
            this.getProductosOrder();
            this.getCategory();
        },
        cancelarEdicion() {

            this.listProductos.forEach(function (x) {
                x.modifier = false;
            });

            this.editarProductos = false
        },
        getProductosOrder() {
            const controller = this.searchQuery ? 'searchProductsByOrden/' + this.searchQuery : 'getProductsByOrden';
            var config = {
                params: {
                    pag: this.pag,
                    idBusiness: this.idBusiness,
                    grupo: this.grupo,
                    filter: this.filter,
                    activo: this.activo,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            this.$store.dispatch("setIdBusiness", this.idBusiness.toString());
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "products/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listProductOrder = response.data.result;

                        vm.respuesta = true;
                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        editProduct(p) {
            var controller = "editProductByProduct";

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            var params = {
                product: p,
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt
            };

            let vm = this;

            this.axios.post(this.$store.getters.apiUrl + 'products/' + controller, params, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.$notify({
                            message: vm.$t('productosEditadosCorrectamente'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                        vm.getProductos();

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                });
        },
        editProductOrden() {
            var controller = "updateProductsByOrden";

            var config = {
                params: {
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };
            var params = {
                listProducts: this.listProductOrder,
                idBusiness: this.idBusiness,
                jwt: this.$store.getters.jwt
            };

            let vm = this;

            this.axios.post(this.$store.getters.apiUrl + 'products/' + controller, params, config)
                .then(function (response) {
                    if (response.data.response) {

                        vm.ordenarProductos = false;
                        vm.$notify({
                            message: vm.$t('ordenActualizadoCorrectamente'),
                            icon: 'nc-icon nc-check-2',
                            timeout: 2000,
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'success'
                        });

                    } else {
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });
                    }
                });
        },



        getProductos() {
            const controller = this.searchQuery ? 'searchProductsById/' + this.searchQuery : 'getProducts';
            var config = {
                params: {
                    pag: this.pag,
                    idBusiness: this.idBusiness,
                    filter: this.filter,
                    activo: this.activo,
                    jwt: this.$store.getters.jwt
                },
                headers: { 'Authorization': "Bearer " + this.$store.getters.jwt }
            };

            

            this.$store.dispatch("setIdBusiness", this.idBusiness.toString());
            let vm = this;
            this.axios.get(this.$store.getters.apiUrl + "products/" + controller, config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.pag = response.data.result.pag;
                        vm.totalPags = response.data.result.totalPags;

                        vm.listProductos = [];

                        response.data.result.products.forEach(function (x) {

                            let xProduct = {
                                active: x.active,
                                costprice: x.costprice,
                                id: x.id,
                                name: x.name,
                                description: x.description,
                                barcode: x.barCode,
                                nameCat: x.nameCat,
                                price1: x.price1,
                                price2: x.price2,
                                price3: x.price3,
                                price4: x.price4,
                                price5: x.price5,
                                modifier: false,
                                idCate: x.idCate,
                                vatType: Math.trunc(x.vatType),
                            };

                            vm.listProductos.push(xProduct);
                        });

                        vm.respuesta = true;
                        vm.loadingGeneral.close();
                    } else {
                        vm.loadingGeneral.close();
                        swal({
                            title: vm.$t('atencion'),
                            text: response.data.message,
                            confirmButtonClass: 'btn btn-info btn-fill',
                            type: 'error'
                        });

                        vm.respuesta = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        searchProveedores() {
            if (this.searchQuery !== undefined && this.searchQuery !== "") {
                this.$router.push({ name: 'search-productos', params: { query: this.searchQuery  } });
                this.isSearch = true;
            }
        },
        removeSearch() {
            if (this.searchQuery && this.searchQuery !== "") {
                this.searchQuery = "";
                this.isSearch = false;
                this.$router.push({ name: 'productos' });
                this.getProductos();
                this.getProductosOrder()
            }
        },

        changeIsDeBaja() {
            
            

            if (this.isDeBaja) {
                this.activo = 0
            } else {
                this.activo = 1
            }

            this.getProductos()
            this.getProductosOrder()
            
        },
    }
}
</script>

<style scoped>
tbody tr:hover {
    background-color: rgba(0, 153, 130, 0.2);
    cursor: pointer;
}

tbody td {
    padding: 0 !important;
}

td div {
    padding: 12px 8px;
    color: #333;
}

.buttonProducto {
    font-size: 0.9em;
    margin-bottom: 3px;
    text-align: center;
    padding: 5px;
    width: 100%;
    height: 70px;
    border-width: 1px;
    border-radius: 3px;
    background-color: #cad3ff;
}

.buttonsSearch:hover {
    cursor: pointer;
    background-color: rgba(0, 153, 130, 0.1);
}

.titulo {
    text-align: center;
    background-color: #111;
    color: white;
    text-transform: uppercase;
    font-size: 1.1em;
}

.card {
    padding: 20px;
}

.input-group button {
    height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Productos/Productos.vue